(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fast-flow-choose-ll"]) return;
  try {
    
$(document).ready(function() {
    // Use event delegation to ensure handlers work even if elements are dynamically rendered
    // 6-polish choice: show Continue directly (no formula step)
    $(document).on('click', '.sixChoice', function() {
        $('.pchoices').removeClass('active').addClass('inactive');
        $(this).addClass('active');
        $('.toggle').hide();
        $('.six-color').show().focus();
        $('.pchoices').prop('ariaChecked', false);
        $(this).prop('ariaChecked', true);
    });

    // 1-polish choice: show Continue directly (no formula step)
    $(document).on('click', '.oneChoice', function() {
        $('.pchoices').removeClass('active').addClass('inactive');
        $(this).addClass('active');
        $('.toggle').hide();
        $('.one-color').show().focus();
        $('.pchoices').prop('ariaChecked', false);
        $(this).prop('ariaChecked', true);
    });

    $(document).on('click', '.extraChoice', function() {
        $('.pchoices').removeClass('active').addClass('inactive');
        $(this).addClass('active');
        $('.toggle').hide();
        $('.extra').show().focus();
        $('.pchoices').prop('ariaChecked', false);
        $(this).prop('ariaChecked', true);
    });

    $(document).on('click', '.extraChoice2', function() {
        $('.pchoices').removeClass('active').addClass('inactive');
        $(this).addClass('active');
        $('.toggle').hide();
        $('.extra2').show().focus();
        $('.pchoices').prop('ariaChecked', false);
        $(this).prop('ariaChecked', true);
    });

    $(document).on('click', '.dis', function() {
        $('.error').show().focus();
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fast-flow-choose"]) return;
  try {
    
$(document).ready(function() {
    $('.sixChoice').on('click', function() {
        $('.pchoices').removeClass('active').addClass('inactive');
        $(this).addClass('active');
        $('.toggle').hide();
        $('.six-color').show().focus();  // Shift focus to the "Continue" button
        $('.pchoices').prop('ariaSelected', false);
        $(this).prop('ariaSelected', true);
    });

    $('.oneChoice').on('click', function() {
        $('.pchoices').removeClass('active').addClass('inactive');
        $(this).addClass('active');
        $('.toggle').hide();
        $('.one-color').show().focus();  // Shift focus to the "Continue" button
        $('.pchoices').prop('ariaSelected', false);
        $(this).prop('ariaSelected', true);
    });

    $('.extraChoice').on('click', function() {
        $('.pchoices').removeClass('active').addClass('inactive');
        $(this).addClass('active');
        $('.toggle').hide();
        $('.extra').show().focus();  // Shift focus to the "Continue" button
        $('.pchoices').prop('ariaSelected', false);
        $(this).prop('ariaSelected', true);
    });

        $('.extraChoice2').on('click', function() {
        $('.pchoices').removeClass('active').addClass('inactive');
        $(this).addClass('active');
        $('.toggle').hide();
        $('.extra2').show().focus();  // Shift focus to the "Continue" button
        $('.pchoices').prop('ariaSelected', false);
        $(this).prop('ariaSelected', true);
    });

    $('.llChoice').on('click', function() {
        $('.fchoices').removeClass('active').addClass('inactive');
        $(this).addClass('active');
        $('.ftoggle').hide();
        $('.long-lasting-cta').show().focus();  // Shift focus to the "Continue" button
        $('.fchoices').prop('ariaSelected', false);
        $(this).prop('ariaSelected', true);
    });

    $('.qdChoice').on('click', function() {
        $('.fchoices').removeClass('active').addClass('inactive');
        $(this).addClass('active');
        $('.ftoggle').hide();
        $('.quick-dry-cta').show().focus();  // Shift focus to the "Continue" button
        $('.fchoices').prop('ariaSelected', false);
        $(this).prop('ariaSelected', true);
    });

    $('.mmChoice').on('click', function() {
        $('.fchoices').removeClass('active').addClass('inactive');
        $(this).addClass('active');
        $('.ftoggle').hide();
        $('.mix-match-cta').show().focus();  // Shift focus to the "Continue" button
        $('.fchoices').prop('ariaSelected', false);
        $(this).prop('ariaSelected', true);
    });

    $('.fbacked').on('click', function() {
        $('.formula-pick').hide();
        $('.polish-pick').show().focus();  // Shift focus back to the polish selection section
    });

    $('.six-cta').on('click', function() {
        $('.formula-6').show().focus();  // Shift focus to the formula selection section
        $('.polish-pick').hide();
    });

    $('.one-cta').on('click', function() {
        $('.polish-pick').hide();
        $('.formula-1').show().focus();  // Shift focus to the formula selection section
    });

    $('.dis').on('click', function() {
        $('.error').show().focus();  // Shift focus to the error message
    });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-hero-seas-image"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlider(slider) {
      if (slider.dataset.initialized === 'true') return;
      slider.dataset.initialized = 'true';

      var slides = Array.prototype.slice.call(slider.querySelectorAll('.slide'));
      var prevBtn = slider.querySelector('.slider-prev');
      var nextBtn = slider.querySelector('.slider-next');
      var dotsContainer = slider.querySelector('.slider-dots');

      // Single-slide: hide controls and bail
      if (slides.length <= 1) {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
        if (dotsContainer) dotsContainer.style.display = 'none';
        // Still ensure the lone slide is visible and video plays
        if (slides[0]) {
          slides[0].classList.add('is-active');
          var v = slides[0].querySelector('video');
          if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        }
        return;
      }

      var currentIndex = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
      if (currentIndex < 0) currentIndex = 0;

      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var autoplayEnabled = slider.dataset.autoplay !== 'false' && !prefersReducedMotion;
      var interval = parseInt(slider.dataset.autoplayInterval, 10) || 7000;
      var autoplayTimer = null;
      var paused = false;

      // Build dots
      var dots = slides.map(function (_, i) {
        var dot = document.createElement('button');
        dot.className = 'slider-dot' + (i === currentIndex ? ' is-active' : '');
        dot.type = 'button';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.setAttribute('aria-selected', i === currentIndex ? 'true' : 'false');
        dot.addEventListener('click', function () { goTo(i); });
        dotsContainer.appendChild(dot);
        return dot;
      });

      function handleVideo(slide, shouldPlay) {
        var video = slide.querySelector('video');
        if (!video) return;
        if (shouldPlay) {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          video.pause();
        }
      }

      // Initialize: only play the active slide's video
      slides.forEach(function (slide, i) { handleVideo(slide, i === currentIndex); });

      function goTo(newIndex) {
        newIndex = ((newIndex % slides.length) + slides.length) % slides.length;
        if (newIndex === currentIndex) return;

        var oldSlide = slides[currentIndex];
        var newSlide = slides[newIndex];

        oldSlide.classList.remove('is-active');
        oldSlide.classList.add('is-leaving');
        newSlide.classList.add('is-active');

        // Cleanup leaving class after transition
        window.setTimeout(function () { oldSlide.classList.remove('is-leaving'); }, 600);

        // Update dots
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === newIndex);
          dot.setAttribute('aria-selected', i === newIndex ? 'true' : 'false');
        });

        // Swap video playback
        handleVideo(oldSlide, false);
        handleVideo(newSlide, true);

        currentIndex = newIndex;
        resetAutoplay();
      }

      function next() { goTo(currentIndex + 1); }
      function prev() { goTo(currentIndex - 1); }

      // Arrow controls
      if (prevBtn) prevBtn.addEventListener('click', prev);
      if (nextBtn) nextBtn.addEventListener('click', next);

      // Autoplay
      function startAutoplay() {
        if (!autoplayEnabled || paused) return;
        stopAutoplay();
        autoplayTimer = window.setInterval(next, interval);
      }
      function stopAutoplay() {
        if (autoplayTimer) { window.clearInterval(autoplayTimer); autoplayTimer = null; }
      }
      function resetAutoplay() { stopAutoplay(); startAutoplay(); }

      // Pause on hover / focus
      slider.addEventListener('mouseenter', function () { paused = true; stopAutoplay(); });
      slider.addEventListener('mouseleave', function () { paused = false; startAutoplay(); });
      slider.addEventListener('focusin',   function () { paused = true; stopAutoplay(); });
      slider.addEventListener('focusout',  function (e) {
        if (!slider.contains(e.relatedTarget)) { paused = false; startAutoplay(); }
      });

      // Pause when offscreen
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) startAutoplay();
            else stopAutoplay();
          });
        }, { threshold: 0.25 });
        io.observe(slider);
      }

      // Pause when tab hidden
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stopAutoplay();
        else startAutoplay();
      });

      // Keyboard nav
      slider.setAttribute('tabindex', '0');
      slider.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft')  { e.preventDefault(); prev(); }
        if (e.key === 'ArrowRight') { e.preventDefault(); next(); }
      });

      // Touch swipe
      var touchStartX = 0, touchStartY = 0;
      slider.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });
      slider.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = e.changedTouches[0].clientY - touchStartY;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) next(); else prev();
        }
      }, { passive: true });

      startAutoplay();
    }

    function initAll() {
      var sliders = document.querySelectorAll('.hero-slider');
      Array.prototype.forEach.call(sliders, initSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Re-init when section is reloaded in the Shopify theme editor
    document.addEventListener('shopify:section:load', function (e) {
      var slider = e.target.querySelector('.hero-slider');
      if (slider) initSlider(slider);
    });
  })();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-trends-row"] && !Shopify.designMode) return;
  try {
    
(function () {
  const toggles = document.querySelectorAll('[data-motion-toggle]');

  toggles.forEach(function (toggle) {
    const tile = toggle.closest('.col-desc--video');
    if (!tile) return;

    const video = tile.querySelector('[data-bg-video]');
    const icon = toggle.querySelector('.col-desc__motion-toggle-icon');
    const label = toggle.querySelector('[data-motion-label]');
    if (!video) return;

    toggle.addEventListener('click', function () {
      if (video.paused) {
        video.play();
        toggle.setAttribute('aria-pressed', 'false');
        if (icon) icon.textContent = '⏸';
        if (label) label.textContent = 'Pause background video';
      } else {
        video.pause();
        toggle.setAttribute('aria-pressed', 'true');
        if (icon) icon.textContent = '▶';
        if (label) label.textContent = 'Play background video';
      }
    });

    // If the OS-level reduced motion preference is set, start paused.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.pause();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
